import { createTheme } from "@material-ui/core";

export const darkTheme = createTheme({
  palette: {
    primary: {
      main: "#fff"
    },
    type: "dark"
  }
});
